<template>
    <div class="search-results">
        <ul class="uk-list" v-if="searchResults && searchResults.length && searchResults.some(result => result.visible !== false)">
            <li
                tabinex="0"
                @mouseenter="hoverItem(result)"
                @mouseleave="hoverItem(null)"
                v-for="result in searchResults" :key="result.id" class="uk-text-primary">

                <h5 class="uk-h4 uk-margin-small-bottom uk-text-semibold">
                    <a  tabindex="0"
                    @focus="hoverItem(result)" v-if="result.url" :href="result.url">{{result.name}} <span uk-icon="icon: nv-arrow; ratio: 0.7"></span></a>
                    <span v-else>{{result.name}}</span>
                </h5>

                <span v-if="result.projectStatusDisplayValue && result.docTypeAlias != 'mainProject'">
                    <span class="uk-text-bold" style="margin-right: 4px;">Status:</span>{{ result.projectStatusDisplayValue }}
                </span>
                <span v-if="result.projectStatus && result.docTypeAlias == 'mainProject'">
                    <span class="uk-text-bold">Status:</span> {{ result.projectStatus }}
                </span>
                <div v-if="result.projectStatusDisplayValue" class="uk-margin-xsmall-top">
                    <span class="uk-label">
                        <span v-if="result.projectStatus" class="uk-margin-xsmall-right" :uk-icon="getIcon(result.projectStatus)"></span>
                        <span>{{ result.projectStatusDisplayValue }}</span>
                    </span>
                </div>
            </li>
        </ul>

        <div v-else class="uk-text-center">Fant ingen treff. Forsøk et annet område i kartet eller andre søkekriterier.</div>
    </div>
</template>

<script setup lang="ts">
import { defineEmits } from 'vue';
import { ISearchResult } from '@/interfaces/SearchResult'
defineProps({
    searchResults: Array as () => ISearchResult[]
})

const emit = defineEmits(['hoverItem'])

function getIcon(status: string){
    return `icon: ${status.toLowerCase()}; ratio: 0.7`
}
function hoverItem(result: ISearchResult | null) {
    emit('hoverItem',result)
}
</script>
<style scoped>
li{
    border-bottom: 1px solid #D9D9D9;
    margin-top: 32px;
    padding-bottom: 32px;
}
</style>